import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import { DiscoIcon, DiscoIconButton } from "@disco-ui"
import DiscoSidebarHeader from "@disco-ui/sidebar/DiscoSidebarHeader"

type Props = {
  fullView: boolean
}

export default function BrainSearchSidebarHeader({ fullView }: Props) {
  const bot = useBrainSearchBot()
  const drawer = useGlobalDrawer("brainSearch")

  if (!bot) return null
  return (
    <DiscoSidebarHeader
      title={bot.name}
      icon={"stars"}
      actions={
        <>
          <DiscoIconButton
            onClick={() => drawer.setParams({ convId: undefined, drawerView: undefined })}
            width={40}
            height={40}
            svgStyles={{ width: 16, height: 16 }}
            tooltip={"New Conversation"}
          >
            <DiscoIcon icon={"edit"} />
          </DiscoIconButton>
          {/* Show a close button when the sidebar is the full view of the drawer */}
          {fullView && (
            <DiscoIconButton
              onClick={drawer.close}
              testid={"BrainSearchPageHeader.close-button"}
              width={40}
              height={40}
              svgStyles={{ width: 20, height: 20 }}
            >
              <DiscoIcon icon={"close"} />
            </DiscoIconButton>
          )}
        </>
      }
    />
  )
}
